import React from 'react';
import { PageHero } from '../components/PageHero';
import { BidsTenders } from '../components/BidsTenders';
export function BidsPage() {
  return <>
      <PageHero breadcrumb="Bids & Tenders" title="Bids & Tenders" subtitle="Explore current procurement opportunities and submit your proposals." data-id="element-290" />
      <BidsTenders data-id="element-291" />
    </>;
}